import { lazy, type ComponentType, type LazyExoticComponent } from "react"
import type { LucideIcon } from "lucide-react"
import {  Sparkles, Wrench, FileSearch, HeartPulse, Route, ClipboardCheck } from "lucide-react"
// Activity,
export interface ToolDef {
  id: string
  name: string
  description?: string
  icon: LucideIcon
  component: LazyExoticComponent<ComponentType>
}

export const tools: ToolDef[] = [
  {
    id: "hr-checker",
    name: "心率完整性检查",
    description: "批量检查 Polar 心率数据文件的完整性和异常",
    icon: HeartPulse,
    component: lazy(() => import("./hr-checker")),
  },
  {
    id: "file-compare",
    name: "表格文件名对比",
    description: "对比 Excel/CSV 表格与本地文件夹，检测缺失、多余和重复项",
    icon: FileSearch,
    component: lazy(() => import("./file-compare")),
  },
  {
  id: "long-distance-checker",
  name: "长距离数据检查",
  description: "批量检查运动数据完整性（Polar/佳明/华为/小米）",
  icon: Route,   // 可换成其他 Lucide 图标
  component: lazy(() => import("./long-distance-checker")),
},
  {
    id: "data-checker",
    name: "数据检查工具",
    description: "可配置规则的运动数据目录完整性检查（支持参数 & glob）",
    icon: ClipboardCheck,
    component: lazy(() => import("./data-checker")),
  },
  {
    id: "example",
    name: "示例工具",
    description: "将本地 HTML/JS 小工具迁移到这里的模板",
    icon: Sparkles,
    component: lazy(() => import("./example")),
  },
  
]

export const toolsById: Record<string, ToolDef> = Object.fromEntries(
  tools.map((t) => [t.id, t])
)

export const DefaultToolIcon = Wrench
